import {
    AMap,
    AMapGeocoder,
    AMapMarker,
    AMapMouseTool,
    AMapPolygon,
    AMapInfoWindow,
} from 'vue2amap'

// 高德地图组件混入
export default {
    components: {
        AMap,
        AMapGeocoder,
        AMapMarker,
        AMapMouseTool,
        AMapPolygon,
        AMapInfoWindow,
    },
}
